import type { T_CountryItem } from '@fe/types/modules/localization/common/client/types';
import { useContext } from 'preact/hooks';

import { CountryCodeSelectorContext } from '@/context/CountryCodeSelectorContext';

import CountryCodeItem from './CountryCodeItem';

export default function CountryCodeList() {
  const { filteredCodes } = useContext(CountryCodeSelectorContext);

  return (
    <div className='max-h-60 space-y-1 overflow-y-auto'>
      {filteredCodes
        ?.filter((c): c is T_CountryItem => !!c.dialCode)
        .map((c) => (
          <CountryCodeItem key={`${c.isoCode}-${c.dialCode}`} country={c} />
        ))}
    </div>
  );
}
